module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('b-modal', {
    attrs: {
      "centered": "",
      "scrollable": "",
      "size": "xl",
      "title": "图片设置"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("\n      确定\n    ")])]
      },
      proxy: true
    }], null, false, 2537272672),
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "align": _vm.data.align
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.data.imgUrl,
      "width": _vm.data.width,
      "height": _vm.data.height,
      "alt": _vm.data.alt
    }
  })]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-row', {
      key: index,
      staticClass: "my-1"
    }, [_c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_c('label', [_vm._v(_vm._s(option.text))])]), _vm._v(" "), _c('b-col', {
      attrs: {
        "sm": "10"
      }
    }, [(option.tag === 'input') ? _c('b-form-input', {
      attrs: {
        "type": option.type
      },
      model: {
        value: (_vm.data[option.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, option.field, $$v)
        },
        expression: "data[option.field]"
      }
    }) : (option.tag === 'select') ? _c('b-form-select', {
      attrs: {
        "options": _vm.selectOptions[option.field]
      },
      model: {
        value: (_vm.data[option.field]),
        callback: function($$v) {
          _vm.$set(_vm.data, option.field, $$v)
        },
        expression: "data[option.field]"
      }
    }) : _vm._e()], 1)], 1)
  }), 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2c43abcb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WelcomeSettings/ImageConf.vue
// module id = Rxdq
// module chunks = 4